import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAtom } from '@fortawesome/free-solid-svg-icons'

const Loader: React.FC = () => {
	return (
		<div className="h-small flex-center">
			<FontAwesomeIcon className="loader text-blue" icon={faAtom} />
		</div>
	)
}

export default Loader
